export default "__VITE_ASSET__DieD3xKx__"